import { render } from "./ProductPublishingDialog.vue?vue&type=template&id=5691962c"
import script from "./ProductPublishingDialog.vue?vue&type=script&lang=js"
export * from "./ProductPublishingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__